import script from "./restaurantInfoAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./restaurantInfoAdd.vue?vue&type=script&setup=true&lang=js"

import "./restaurantInfoAdd.vue?vue&type=style&index=0&id=4ab205d3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ab205d3"]])

export default __exports__